import { BehaviorSubject, Observable } from 'rxjs';

export class AppStateService {

    private isAuthenticated = new BehaviorSubject<boolean>(false);
    private navAsVendor = new BehaviorSubject<boolean>(null);
    private navAsPartner = new BehaviorSubject<object>(null);
    private appState = new BehaviorSubject<object>(null);
    private jobDetailUserRole = new BehaviorSubject<object>(null);
    private userSelectedAccount = new BehaviorSubject<object>(null);
    private selectedAccount = '';
    private accessType = '';
    private homeUrl = '';
    private adminAccessPermission = undefined;
    private userTypeSlug = '';
    private randomNumber = Math.floor(Math.random() * 1000000);

    /* getter/setter for the adminAccessPermission */
    setAdminAccessPermission(adminAccessPermission: boolean) {
        this.adminAccessPermission = adminAccessPermission;
    }
    getAdminAccessPermission() {
        return this.adminAccessPermission;
    }

    /* getter/setter for the selected accountId */
    setSelectedAccount(accountId: string) {
        this.selectedAccount = accountId;
    }
    getSelectedAccount() {
        return this.selectedAccount;
    }

    /* getter/setter for the user access type */
    setAccessType(accessType: string) {
        this.accessType = accessType;
    }
    getAccessType() {
        return this.accessType;
    }

    /* getter/setter to redirect to user's landing page url */
    setHomeUrl(homeUrl: string) {
        this.homeUrl = homeUrl;
    }
    getHomeUrl() {
        return this.homeUrl;
    }

    setAuthState(isLoggedIn: boolean) {
        this.isAuthenticated.next(isLoggedIn);
    }
    getAuthState() {
        return this.isAuthenticated.asObservable();
    }

    setNavAsVendor(account: any) {
        this.navAsVendor.next(account);
    }
    getNavAsVendor() {
        return this.navAsVendor;
    }

    setNavAsPartner(account: any) {
        this.navAsPartner.next(account);
    }
    getNavAsPartner() {
        return this.navAsPartner;
    }

    setAppState(appState: any) {
        this.appState.next(appState);
    }
    getAppState() {
        return this.appState;
    }

    setJobDetailUserRole(jobDetailUserRole: any) {
        this.jobDetailUserRole.next(jobDetailUserRole);
    }
    getJobDetailUserRole() {
        return this.jobDetailUserRole;
    }

    /* getter/setter for the user user type slug*/
    setUserTypeSlug(userTypeSlug: string) {
        this.userTypeSlug = userTypeSlug;
    }
    getUserTypeSlug() {
        return this.userTypeSlug;
    }

    setUserSelectedAccount(userSelectedAccount: any) {
        this.userSelectedAccount.next(userSelectedAccount);
    }
    getUserSelectedAccount() {
        return this.userSelectedAccount;
    }
    getTabUniqueId() { 
        return 'v1-00120' + this.randomNumber;
    }
    setCookie(name,value, sec=10) {
        const date = new Date();
        date.setTime(date.getTime() + (sec * 1000));
        const expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}
